module.exports = __webpack_public_path__ + "assets/f48de945c5e5bebb2ee26776fc453816.mp3";